import { ChatBotQueueCode } from "@/protocols/chatBot"

export type QueueItem = {
	label: string
	code: ChatBotQueueCode
	description: string
}

export type QueueGroup = {
	label: string
	summary: string
	queues: QueueItem[]
}

export const QUEUE_GROUPS: QueueGroup[] = [
	{
		label: "Novos",
		summary: "Fila geral · Fila de equipe · Fila de usuário",
		queues: [
			{
				label: "Fila geral",
				code: "General",
				description: "Conversas aguardando atendimento, direcionadas a qualquer atendente"
			},
			{
				label: "Fila de equipe",
				code: "Team",
				description: "Conversas aguardando atendimento, direcionadas a uma equipe"
			},
			{
				label: "Fila de usuário",
				code: "User",
				description: "Conversas aguardando atendimento, direcionadas a um atendente específico"
			}
		]
	},
	{
		label: "Em atendimento",
		summary: "Em atendimento · Soneca",
		queues: [
			{
				label: "Em atendimento",
				code: "on-going",
				description: "Conversas em andamento com um atendente"
			},
			{
				label: "Soneca",
				code: "snooze",
				description: "Conversas adiadas que voltam para o atendente depois"
			}
		]
	}
]

export const isQueueActive = (
	allowedQueues: Partial<Record<ChatBotQueueCode, boolean>> | undefined,
	code: ChatBotQueueCode
): boolean => {
	return allowedQueues?.[code] ?? true
}

export const buildCompleteAllowedQueuesMap = (
	groups: QueueGroup[],
	allowedQueues: Partial<Record<ChatBotQueueCode, boolean>> | undefined,
	overrides: Partial<Record<ChatBotQueueCode, boolean>>
): Record<ChatBotQueueCode, boolean> => {
	const completeMap = {} as Record<ChatBotQueueCode, boolean>
	groups.forEach(group => {
		group.queues.forEach(queue => {
			const overrideValue = overrides[queue.code]
			completeMap[queue.code] = overrideValue !== undefined
				? overrideValue
				: isQueueActive(allowedQueues, queue.code)
		})
	})
	return completeMap
}
